<script setup lang="ts">
import { computed, ref } from 'vue';
const props = withDefaults(defineProps<{
  open?: boolean;
  containerClass?: string;
  openClass?: string;
  closedClass?: string;
  openIcon?: string;
  closedIcon?: string;
  openIconColor?: string;
  closedIconColor?: string;
}>(), {
  open: false,
  containerClass: 'p-4 rounded shadow-md',
  openClass: 'bg-white',
  closedClass: 'bg-slate-200',
  openIcon: 'minus',
  closedIcon: 'plus',
  openIconColor: 'text-yellow-500',
  closedIconColor: 'text-blue-500',
});

const contentOpen = ref<boolean>(props.open);

const accordionBg = computed(() => contentOpen.value ? props.openClass : props.closedClass);
const spanIcon = computed(() => contentOpen.value ? props.openIcon : props.closedIcon);
const spanIconColor = computed(() => contentOpen.value ? props.openIconColor : props.closedIconColor);
const containerClass = computed(() => `flex-1 duration-300 ${props.containerClass} ${accordionBg.value}`);

const beforeEnter = (el: Element): void => {
  const element = el as HTMLElement;
  element.style.maxHeight = '0';
  element.style.opacity = '0';
};

const enter = (el: Element): void => {
  const element = el as HTMLElement;
  element.style.maxHeight = element.scrollHeight + 'px';
  element.style.opacity = '1';
  element.style.transition = 'max-height 0.2s ease, opacity 0.3s ease';
};

const afterEnter = (el: Element): void => {
  const element = el as HTMLElement;
  element.style.maxHeight = '';
  element.style.opacity = '';
};

const beforeLeave = (el: Element): void => {
  const element = el as HTMLElement;
  element.style.maxHeight = element.scrollHeight + 'px';
  element.style.opacity = '1';
};

const leave = (el: Element): void => {
  const element = el as HTMLElement;
  element.style.maxHeight = '0';
  element.style.opacity = '0';
  element.style.transition = 'max-height 0.3s ease, opacity 0.2s ease';
};
</script>

<template>
  <div class="flex">
    <div :class="containerClass">
      <div class="flex justify-between cursor-pointer" @click="contentOpen = !contentOpen">
        <span class="font-bold">
          <slot name="title"></slot>
        </span>
        <button class="rounded-full">
          <hfc-icon :icon="spanIcon" :class="spanIconColor" />
        </button>
      </div>
      <transition
        name="faq"
        @before-enter="beforeEnter"
        @enter="enter"
        @after-enter="afterEnter"
        @before-leave="beforeLeave"
        @leave="leave"
      >
        <div v-show="contentOpen" class="mt-6">
          <slot name="content"></slot>
        </div>
      </transition>
    </div>
  </div>
</template>
